import { TextField } from "@mui/material";
import { capitalize } from "../../utils/capitalize";

type IProps = {
  formik: any;
  name: string;
  label: string;
  sx?: any;
  color?: any;

  type?: string;
  multiline?: boolean;
  rows?: number;
  onChange?: any;
  placeholder?: string;
};

const FormikInput: React.FC<IProps> = ({
  formik,
  name,
  label,
  sx,
  onChange,
  type = "text",
  color = "primary",

  multiline = false,
  rows = 1,
  placeholder,
}) => {
  return (
    <TextField
      color={color}
      fullWidth
      id={name}
      name={name}
      label={capitalize(label)}
      placeholder={placeholder}
      multiline={multiline}
      rows={rows}
      sx={sx}
      type={type}
      value={formik.values[name]}
      onChange={(e) => {
        formik.handleChange(e);
        if (onChange) {
          onChange(e);
        }
      }}
      error={formik.touched[name] && Boolean(formik.errors[name])}
      helperText={formik.touched[name] && formik.errors[name]}
    />
  );
};

export default FormikInput;
